import React from 'react';

import { Skeleton, Stack } from '@eluve/components';

export const ChatPanelSkeleton: React.FC = () => (
  <Stack className="flex-1 p-4" gap={4}>
    <Skeleton className="h-16 w-full rounded-lg" />
    <Skeleton className="h-16 w-full rounded-lg" />
    <Skeleton className="h-16 w-full rounded-lg" />
    <div className="mt-auto">
      <Skeleton className="h-12 w-full rounded-lg" />
    </div>
  </Stack>
);
